import React from "react";
import * as s from "./subscribeBlock.module.css";
import { useRef, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import CheckboxDropdown from "../checkboxSelect/checkboxSelect";
import { webhookEvents, formValidation } from "../../../utils/webhookService";

const SubscribeBlockBlog = () => {
    const form = useRef();

    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [selectedValues, setSelectedValues] = React.useState([]);
    const [errors, setErrors] = React.useState({
        firstName: null,
        lastName: null,
        email: null,
    });
    const [isOpen, setIsOpen] = React.useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const handleDropdownChange = (selectedOptions) => {
        setSelectedValues(selectedOptions);
    };
    const [sending, setSending] = React.useState(false);
    const [messageSent, setMessageSent] = React.useState(false);


    const submitForm = (event) => {
        event.preventDefault();
        if (isValidForm()) {
            setSending(true);

            const formData = {
                firstName: firstName || "",
                lastName: lastName || "",
                email: email || "",
                contentType: selectedValues || ""
            };

            webhookEvents.subscriber(formData, {
                onSuccess: () => {
                    setFirstName("");
                    setLastName("");
                    setEmail("");
                    setSelectedValues([]);
                    setErrors({
                        firstName: null,
                        lastName: null,
                        email: null,
                    });
                    setMessageSent(true);
                    setSending(false);
                },
                onError: (error) => {
                    console.error("Subscribe form submission failed:", error);
                    setSending(false);
                }
            });
        }
    }

    const isValidForm = () => {
        let isValid = true;
        let newErrors = {
            firstName: null,
            lastName: null,
            email: null,
        };

        if (!firstName?.length) {
            isValid = false;
            newErrors.firstName = 'Please enter Your Name';
        }
        if (!lastName?.length) {
            isValid = false;
            newErrors.lastName = 'Please enter Your Name';
        }
        if (!isEmailValid(email)) {
            isValid = false;
            newErrors.email = 'Please enter a valid Email';
        }

        setErrors(newErrors);
        return isValid;
    }

    const isEmailValid = (email) => {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }
    return (
        <div className={`${s.formBox}`}>
            <div className="container">
                {!!messageSent ?
                    <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                        <div className={`${s.thankYou} text-center`}>
                            <span>
                                Thank you!
                                <br /> You are Subscribed!
                            </span>
                        </div>
                    </div>
                    :
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <h3 className={`${s.formBoxTitle}`}>Your Inbox, Your Rules!</h3>
                            <h4 className={s.formBoxSubtitle}>Tailor your newsletter
                                with the topics
                                you're most interested in.</h4>
                        </div>
                        <div className="col-12 col-md-7">

                            <form onSubmit={submitForm} className="row justify-content-center">
                                <input type="hidden" name="form_type" value="subscribe_form" />
                                <div className="col-12 px-lg-2">
                                    <label>First Name</label>
                                    <input type="text" name="firstname" className={`${null != errors.firstName ? s.invalid : ''}`}
                                        value={firstName} onChange={e => setFirstName(e.target.value)} required pattern="^(?!\s*$).+" />
                                </div>
                                <div className="col-12 px-lg-2">
                                    <label>Last Name</label>
                                    <input type="text" name="lastname" className={`${null != errors.lastName ? s.invalid : ''}`}
                                        value={lastName} onChange={e => setLastName(e.target.value)} required pattern="^(?!\s*$).+" />
                                </div>
                                <div className="col-12 px-lg-2">
                                    <label>Email</label>
                                    <input type="email" name="email" className={`${null != errors.email ? s.invalid : ''}`}
                                        value={email} onChange={e => setEmail(e.target.value)} required />
                                </div>
                                <div className="col-12 px-lg-2">
                                    <label>Preferred Content Type</label>
                                    <CheckboxDropdown options={[
                                        'Industry News',
                                        'Industry Reports',
                                        'Expert Insights',
                                        'Tips & Tricks',
                                        'Product Updates',
                                        'Exclusive Offers',
                                        'Events & Webinars',
                                        'Customer Spotlights',
                                    ]}
                                        selectedValues={selectedValues}
                                        onChange={handleDropdownChange} />
                                </div>
                                <div className="col-12 px-lg-2">
                                    <button type="submit" disabled={sending}>Subscribe</button>
                                </div>
                            </form>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default SubscribeBlockBlog;
